import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Alert } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/PaymentSuccess.css"; // We'll reuse the styles

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(5);

  const { 
    membershipType, 
    paymentDetails, 
    membershipData, 
    loginCredentials 
  } = location.state || {};

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/member-login');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <>
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container payment-success-content-container">
          <section className="payment-success-section">
            <Container className="">
              <h2 className="text-center payment-success-heading mb-4 pt-4">
                Payment Successful!
              </h2>

              <Row className="justify-content-center pb-5">
                <Col md={6}>
                  <Card className="p-4 shadow-sm payment-success-card">
                    <div className="text-center">
                      <div className="success-icon mb-4">
                        <i className="fas fa-check-circle" style={{ fontSize: '48px', color: '#28a745' }}></i>
                      </div>
                      
                      <h3 className="mb-3">Thank You!</h3>
                      
                      <p className="mb-4">
                        Your {membershipType === 'full' ? 'Life' : 'Associate'} Membership payment has been processed successfully.
                      </p>

                      {paymentDetails && (
                        <div className="payment-details mb-4">
                          <p><strong>Order ID:</strong> {paymentDetails.orderId}</p>
                          <p><strong>Payment ID:</strong> {paymentDetails.paymentId}</p>
                          <p><strong>Amount Paid:</strong> ₹{paymentDetails.amountInRupees?.toFixed(2) || (paymentDetails.amount/100).toFixed(2)}</p>
                        </div>
                      )}

                      {loginCredentials && (
                        <div className="login-credentials mb-4">
                          <h5 className="text-success mb-3">
                            <i className="fas fa-envelope me-2"></i>
                            Login Credentials
                          </h5>
                          <div className="credentials-info p-3 bg-light rounded">
                            <p className="mb-2">
                              <strong>Email:</strong> {loginCredentials.email}
                            </p>
                            <p className="mb-2 text-info">
                              <i className="fas fa-info-circle me-1"></i>
                              {loginCredentials.message}
                            </p>
                            <p className="mb-0 small text-muted">
                              Please check your email inbox (and spam folder) for your login password.
                            </p>
                          </div>
                        </div>
                      )}

                      <Alert variant="success" className="mb-4">
                        <h6 className="mb-2">
                          <i className="fas fa-check-circle me-2"></i>
                          What happens next?
                        </h6>
                        <ul className="mb-0 small text-start d-flex flex-column justify-content-center">
                          <li>Your membership has been activated</li>
                          <li>Login credentials have been sent to your email</li>
                          <li>You can now access your member dashboard</li>
                          <li>Your membership certificate will be available after approval</li>
                        </ul>
                      </Alert>

                      <Alert variant="info">
                        Redirecting to login page in {countdown} seconds...
                      </Alert>

                      <p className="mt-3">
                        Please login with your registered email and the password sent to your email address.
                      </p>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
